export const ADD_DEPENDENTS = 'add_dependents'
export const REMOVE_DEPENDENTS = 'remove_dependents'
